



























































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import Moment from 'moment';
import FieldText from '@/components/dumb/FieldText.vue';
import FieldPhone from '@/components/dumb/FieldPhone.vue';
import FieldTextarea from '@/components/dumb/FieldTextarea.vue';
import Api from '@/mixins/api';
import Helpers from '@/mixins/helpers';
import axios from 'axios';
import Validation from '../mixins/validation';
import Analytics from '@/mixins/analytics';
import VueRecaptcha from 'vue-recaptcha';

export default Vue.extend({
	name: 'CallbackForm', 
	props: {
		schedule: {
			type: Boolean
		}
	},
	components: {
		FieldText, 
		FieldPhone, 
		FieldTextarea, 
		VueRecaptcha
	},
	data(){
		return {
			isProcessing: false,
			isFormValid: false,
			recaptchaError: false,
			captchaRendered: false,
			form: {
				requestedContactDate: '',
				requestedContactTime: 'asap',
				needFinance: false,
				hasTradeIn: false,
				additionalComment: '', 
				recaptcha: ''
			}
		};
	}, 
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			dealer(): any { return this.$store.state.dealer },
			customer(): any { return this.$store.state.customer },
			vehicle(): any { return this.$store.state.vehicle }
		}), 
		recaptchaErrorMessage(): string {
			if (this.recaptchaError){
				return this.captchaRendered ? 'Captcha is a required field' : 'Your browser has blocked Captcha. Please try a different browser.';
			}
			return '';
		},
		captchaSiteKey(): string {
			return this.$store.getters.captchaSiteKey;
		},
		emailRules(): Array<Function> {
			return [Validation.isEmail];
		}, 
		showTime(): boolean {
			return !!this.form.requestedContactDate && this.now != this.form.requestedContactDate;
		},
		nowLabel(): string {
			return '<small>&nbsp;</small><span>ASAP</span><small>&nbsp;</small>';
		},
		now(): string {
			const d = new Date();
			const m = Moment(d);
			return m.format('Y-MM-DD');
		},
		nowP1(): string {
			const d = new Date();
			d.setDate(d.getDate() + 1);
			const m = Moment(d);
			return m.format('Y-MM-DD');
		},
		nowP2(): string {
			const d = new Date();
			d.setDate(d.getDate() + 2);
			const m = Moment(d);
			return m.format('Y-MM-DD');
		},
		nowP3(): string {
			const d = new Date();
			d.setDate(d.getDate() + 3);
			const m = Moment(d);
			return m.format('Y-MM-DD');
		},
		formName(): string {
			const n = this.schedule ? 'Omnichannel - Schedule Callback' : 'Omnichannel - Email Enquiry';
			return n;
		},
		customerRequestedContactDate: {
			get(): string {
				return this.form.requestedContactDate;
			}, 
			set(v: string): void {
				this.form.requestedContactDate = v;
				if (this.form.requestedContactDate == this.now){
					this.form.requestedContactTime = 'asap';
				}
				else {
					this.form.requestedContactTime = 'morning';
				}
			}
		},
		customerFirstName: {
			get(): string {
				return this.customer.firstName;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					firstName: v
				});
			}
		}, 
		customerPreferredName: {
			get(): string {
				return this.customer.preferredName;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					preferredName: v
				});
			}
		}, 
		customerLastName: {
			get(): string {
				return this.customer.lastName;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					lastName: v
				});
			}
		}, 
		customerPhone: {
			get(): string {
				return this.customer.phone;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					phone: v
				});
			}
		}, 
		customerEmail: {
			get(): string {
				return this.customer.email;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					email: v
				});
			}
		}
	}, 
	methods: {
		setCaptcha(response: string): void {
			Helpers.clog(response);
			this.form.recaptcha = response;
            this.recaptchaError = false;
		},
		removeCaptcha(): void {
			this.form.recaptcha = '';
			this.recaptchaError = true;
		},
		handleCaptchaRendered(): void {
			this.captchaRendered = true;
		},
		handleBackClick(): void {
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": this.formName + " – Cancel"
			});
			this.$emit('cancel');
		},
		handleSubmitClick(): void {
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": this.formName + " – Submit"
			});
			this.isProcessing = true;
			const url = Api.returnEnquiryPostURL();
			const postObject = {
				'DealerID': this.dealer.dealerID,
				'StockDealerID': this.dealer.stockDealerID,
				'PrimaryDealerCode': this.dealer.primaryDealerCode,
				'LocationName': this.dealer.locationName,
				'EnquiryTypeID': this.schedule ? 1 : 2,
				'FirstName': this.customer.firstName,
				'PreferredName': this.customer.preferredName,
				'LastName': this.customer.lastName,
				'Telephone': this.customer.phone,
				'Email': this.customer.email,
				'RequestedContactDate': this.form.requestedContactDate + 'T00:00:00', 
				'RequestedContactTime': this.form.requestedContactTime,
				'NeedFinance':this.form.needFinance,
				'HasTradeIn':this.form.hasTradeIn,
				'Backlink':this.app.referrer,
				'VehicleSpecificationID': this.vehicle.vehicleSpecificationID,
				'Materialcode': this.vehicle.materialCode,
				'VIN': this.vehicle.vin,
				'Model': this.vehicle.model,
				'Grade': this.vehicle.grade,
				'FullDescription': this.vehicle.fullDescription,
				'Paint': this.vehicle.paintName,
				'Trim': this.vehicle.trimName,
				'FactoryOptionDescription': this.vehicle.inclOption,
				'AdditionalComment':this.form.additionalComment, 
				"recaptchaResponse": this.form.recaptcha

			}
			Helpers.clog(postObject);
			axios.post(url, postObject).then(() => {
				Analytics.sendEvent({
					"event": "formSubmit",
					"formName" : this.formName,
					"needsFinance" : this.form.needFinance ? "yes" : "no",
					"hasTradeIn" : this.form.hasTradeIn ? "yes" : "no"
				});
				this.isProcessing = false;
				this.$emit('posted');
			}).catch((error) => {
				Helpers.clog(error);
				this.isProcessing = false;
				this.$emit('posted');
				this.$store.commit('setError', {
					message: `Something went wrong with our system. Please try again later.`
				})
			});
		},
		handleFieldUpdate(fieldName: string): void {
			Analytics.sendEvent({
				"event": "formInteraction",
				"formName" : this.formName,
				"fieldName" : fieldName,
				"fieldStatus" : "Edited"
			});
		},
		getRadioClass(d: string){
			return 'tb-callback-radio' + (d == this.customerRequestedContactDate ? ' tb-active' : '');
		},
		getFriendlyDate(d: string): string {
			const m = Moment(new Date(d));
			return `<small>${m.format('dddd')}</small><span>${m.format('DD')}</span><small>${m.format('MMM')}</small> `; 
		}
	}, 
	mounted(): void {
		(this.form.requestedContactDate as any) = this.now;
	}
});
